<script>
    import InfiniteTree from 'infinite-tree';
    import KeywordsFieldDefs from './../KeywordsFieldDefs'
    import PageItem from './PageItem.vue'
    import TreeSetting from './TreeSetting.vue'
    import {doLangFields, isGoogleGny} from '../../../lib/ks-tools'
    import KeywordsGny from "../KeywordsGny";
    import {nextTick} from "vue";
    import {Listeners} from "../../../constants/listeners";
    import {store} from "../store";
    import KSTable from "../../../component/ks-table/KSTable.vue";
    import KSFilter from "../../../component/ks-filter/KSFilter.vue";

    export default {
        data() {
            return {
                keywordsFields: doLangFields(this, "lang.report.treepages.fields", isGoogleGny() ? KeywordsGny : KeywordsFieldDefs),
                keywordsSortOrder: [
                    {
                        field: 'wsk',
                        direction: 'desc'
                    }
                ],
                infiniteTree: null,
                filter: null,
                scrollHeight: 0,
                nodeIds: [],
                cachedNodes: {},
                includeSubLevels: true,
                selectNode: null,
                titlePadding: 0,
                store: store,
            }
        },
        props: {
            apiUrl: {
                type: String,
                required: true,
            },
            dataTree: {
                type: String,
                required: true,
            },
            settings: {
                type: Object,
                required: true,
            },
            domain: {
                type: String,
                required: true,
            },
        },
        methods: {
            setSetting(setting) {
                this.store.mutations.setSetting(setting);
            },
            setSettingViewCountWeight(weightConfig) {
                this.store.mutations.setSettingViewCountWeight(weightConfig);
            },
            doFilter() {

                let self = this;

                if(!this.filter){
                    this.infiniteTree.unfilter();
                    return false;
                }

                let search = self.filter.split("+");

                const filterOptions = {
                    exactMatch: false
                };

                this.infiniteTree.filter((node) => {
                    const name = node.name || '';

                    let result = false;

                    if(node.id <= 0){
                        return false;
                    }

                    /*if(node.state.selected){
                        return true;
                    }*/

                    if(self.filter){

                        if(search.length > 1){

                            result = search.every((q) => {
                                return (""+name).toLowerCase().indexOf(q.toLowerCase().trim()) >= 0;
                            });

                        }else{
                            result = (""+name).toLowerCase().indexOf(self.filter.toLowerCase().trim()) >= 0;
                        }

                    }

                    return result;

                }, filterOptions);



            },

            onNodeClick(node) {
                this.selectNode = node;
            },

            onNodeClickFromBreadcrumbs(node) {
                this.infiniteTree.selectNode(node);
                this.onNodeClick(node);
                this.$refs.recycleList.scrollToItem(this.nodeIds.indexOf(this.selectNode.id));
            },

            getParts (node, parts = []) {
                parts.push(node.name);

                let parent = node.getParent();

                if(parent.name && parent.name !== "/"){
                    return this.getParts(parent, parts)
                }

                return parts;
            },

            upsertNode(node){

                if (this.cachedNodes[node.id]) {

                    this.cachedNodes[node.id].state.open = node.state.open;
                    this.cachedNodes[node.id].state.depth = node.state.depth;
                    this.cachedNodes[node.id].state.selected = node.state.selected;

                } else {
                    let flattenNodes = this.infiniteTree.flattenChildNodes(node);

                    let path;
                    if(node.name === "/"){
                        path = "/"
                    }else{
                        path = "/" + this.getParts(node).reverse().join('/')
                    }

                    this.cachedNodes[node.id] = {
                        id: node.id,
                        name: node.name,
                        sumIt1: parseInt(node.it1),
                        sumIt3: parseInt(node.it3),
                        sumIt5: parseInt(node.it5),
                        sumIt10: parseInt(node.it10),
                        sumIt50: parseInt(node.it50),
                        sumVis: parseInt(node.vis),
                        has_children: node.children.length > 0,
                        total_flatten: flattenNodes.length,
                        path: path,
                        state: {
                            depth: node.state.depth,
                            open: node.state.open,
                            selected: node.state.selected
                        }
                    }
                }

            },
            hasScrollBar(){
                let el = document.querySelector('.scroller');
                if(el){
                    return el.scrollHeight > el.clientHeight;
                }
                return false;
            },
            onShowTreeSetting() {
                this.$emitter.emit(Listeners.TREE_PAGES_POPUP_SETTING_OPEN);
            }
        },
        computed: {
            getSetting() {
                return this.store.getters.setting();
            },
            getSettingViewCountWeight() {
                return this.store.getters.settingViewCountWeight();
            },
            getCountTitle() {
                return this.store.getters.countTitle();
            },
            nodes(){
                return this.nodeIds.map((ids) => {
                    return this.cachedNodes[ids];
                });
            },
            getApiUrl(){
                if(!this.selectNode){
                    return this.apiUrl;
                }

                let path;
                if(this.selectNode.name === "/"){
                    path = "/"
                }else{
                    path = "/" + this.getParts(this.selectNode).reverse().join('/')
                }

                return this.apiUrl + "&url=" + encodeURIComponent(path) + "&includeSubLevels=" + (this.includeSubLevels ? 1 : 0);
            },
            labelInfoTitle() {
                let result = [];
                if (this.getSetting.view) {
                    for (let p in this.getSetting.view.treeNodeName) {
                        if (this.getSetting.view.treeNodeName[p].enabled) {
                            result.push({
                                key: p,
                                title: this.getCountTitle[p].title,
                                abbr: this.getCountTitle[p].abbr,
                                width: this.getSettingViewCountWeight[p]
                            });
                        }
                    }
                }

                return result.reverse();
            },
            breadcrumbs(){
                let self = this;
                if(this.selectNode && Object.keys(this.selectNode).length > 0){

                    let getBreadcrumbs = function(node, data){

                        let findNode = self.infiniteTree.getNodeById(node.parent.id);
                        if(findNode && findNode.parent){
                            data.push(findNode);
                            return getBreadcrumbs(findNode, data);
                        }

                        return data;
                    };

                    return getBreadcrumbs(self.selectNode, [self.selectNode]).reverse();
                }

                return [];

            },

            pageUrl(){
                return "https://" + this.domain + this.breadcrumbs.map(b => b.name).join('/').substring(1);
            }


        },
        watch: {
            filter(newVal, oldVal) {
                if(!newVal) {
                    this.doFilter();
                }
            },
            nodes() {
                let self = this;
                nextTick(function () {
                    self.titlePadding = self.hasScrollBar() ? 16 : 0;
                });
            }

        },
        components: {
            PageItem,
            TreeSetting,
            'ks-table': KSTable,
            'ks-filter': KSFilter,
        },
        created() {
            this.setSetting(this.settings);

            let options = {
                autoOpen: true,
                tabIndex: 0,
                data: JSON.parse(this.dataTree),
                width: '100%',
                rowRenderer: () => ''
            };

            this.infiniteTree = new InfiniteTree(options);
            let weightConfig = {};

            for (let p in this.getSetting.view.treeNodeName) {
                weightConfig[p] = 0;
            }

            for (let nodeId in this.infiniteTree.nodeTable.data) {

                let node = this.infiniteTree.nodeTable.data[nodeId]
                this.upsertNode(node);

                for (let p in this.getSetting.view.treeNodeName) {
                    if (node[p] >= weightConfig[p]) {
                        weightConfig[p] = node[p];
                    }
                }

            }
            this.setSettingViewCountWeight(weightConfig);
        },
        mounted() {
            let scrollContainer = document.querySelector('.scroller'),
                self = this;

            this.infiniteTree.on('contentDidUpdate', () => {
                if (self.infiniteTree.filtered) {
                    self.nodeIds = self.infiniteTree.nodes.filter((n) => {
                        return n.state.filtered === true
                    }).map((n) => {
                        return n.id
                    });
                } else {
                    self.nodeIds = self.infiniteTree.nodes.map((n) => {
                        return n.id
                    });
                }

                for (let nodeId in self.cachedNodes) {
                    let node = self.infiniteTree.getNodeById(nodeId);
                    self.upsertNode(node);
                }

            });

            this.infiniteTree.unfilter();

            nextTick(function () {
                self.scrollHeight = window.innerHeight - scrollContainer.offsetTop - scrollContainer.offsetParent.offsetTop;

                let startNode = self.infiniteTree.getNodeById(1);
                self.infiniteTree.selectNode(startNode);

                self.onNodeClick(startNode);
            });


        },

    }
</script>
<template>
    <div class="row">

        <div class="col-sm-4 filter" style="padding-top: 2px;">

            <div class="f-row">
                <input type="search" class="cluster_search infinite-tree-scroll-search" v-model="filter" :placeholder="$t('lang.report.treepages.it_search_placeholder')" @keyup.enter="doFilter" ref="input"/>
                <label class="radio ml-2" style="display: inline"><input type="checkbox" v-model="includeSubLevels"><span>{{$t('lang.report.treepages.include_sub_levels')}}</span></label>
                <a href="#" style="float: right" class="graybutton" @click.prevent="onShowTreeSetting" :title="$t('lang.report.treepages.main_setting')"><i class="fa fa-cog" aria-hidden="true"></i></a>
                <tree-setting />
            </div>
            <div class="f-row" :style="{'margin-right': titlePadding + 'px'}">
                <div style="height: 13px; width: 100%; position: relative;">
                    <span v-for="info in labelInfoTitle" class="item-node-info-pt" :title="info.title"
                        :style="{'width': info.width + 'px', 'font-weight': getSetting.sort.field === info.key ? '600' : 'inherit'}" v-html="info.abbr">
                    </span>
                </div>
            </div>
            <recycle-scroller
                    ref="recycleList"
                    :style="{height: scrollHeight + 'px'}"
                    class="scroller"
                    :items="nodes"
                    :item-size="30"
                    key-field="id"
            >

                <template v-slot="props">
                    <PageItem
                        :node="props.item"
                        :tree="infiniteTree"
                        :filter="filter"
                        :on-node-click="onNodeClick"
                    ></PageItem>

                </template>

            </recycle-scroller>

        </div>

        <div class="col-sm-8 filter" ref="right-panel" style="padding-top: 2px;">
            <div class="tree-pages-breadcrumbs">
                <ol v-if="breadcrumbs.length > 0">
                    <li v-for="item in breadcrumbs">
                        <span v-if="item.children.length === 0">{{item.name === '/' ? domain : item.name}}</span>
                        <a v-if="item.children.length > 0" @click.prevent="onNodeClickFromBreadcrumbs(item)">{{item.name === '/' ? domain : item.name}}</a>
                    </li>
                    <li class="pageUrl"><a :href="pageUrl" target="_blank"><i class="fa fa-globe ks-icons" aria-hidden="true"></i></a></li>
                </ol>
            </div>
            <ks-filter :fields="keywordsFields" ref="filter" report-name="treepages" :is-copy="true"
                        :is-download="true" :is-info="false"
            >
            </ks-filter>
            <ks-table
                    v-if="selectNode"
                    ref="ksTable"
                    :fields="keywordsFields"
                    :sort-order="keywordsSortOrder"
                    :api-url="getApiUrl"
                    :enabled-animate="false"
            ></ks-table>

        </div>


    </div>


</template>

<style>

    .infinite-tree-scroll-search{
        width: 50%;
    }

    .scroller {
        height: 100%;
        resize: vertical;
        clear: both;
    }

    .vue-recycle-scroller__item-wrapper .vue-recycle-scroller__item-view{
        white-space: nowrap;
        font-size: 13px;
        height: 30px;
        line-height: 28px;
    }

    .item-node-info-pt {
        float: right;
        font-size: 9px;
        line-height: 13px;
        text-align: center;
        overflow: hidden;
    }
    .tree-pages-breadcrumbs {
        font-size: 13px;
        margin: 0 0 5px;
    }

    .tree-pages-breadcrumbs ol {
        list-style-type: none;
        margin: 0;
        padding: 0;
    }

    .tree-pages-breadcrumbs li {
        display: inline-block;
    }

    .tree-pages-breadcrumbs a {
        text-decoration: none;
        cursor: pointer;
    }

    .tree-pages-breadcrumbs li:not(:nth-last-child(-n+2)):after {
        content: "›\00a0";
        display: inline-block;
        padding-left: .75ch;
        speak: none;
    }

    .tree-pages-breadcrumbs [aria-current="page"] {
        color: inherit;
        font-weight: normal;
        text-decoration: none;
    }

    .tree-pages-breadcrumbs [aria-current="page"]:hover,
    .tree-pages-breadcrumbs [aria-current="page"]:focus {
        text-decoration: underline;
    }
</style>
